import React from "react";
import ReactDOM from "react-dom";
import Loadable from 'react-loadable';
import Loading from "./components/shared/Loading"

const App = Loadable({loader: () => import('./components/App'),loading: () => <Loading/> });
ReactDOM.render(<App />, document.getElementById("root"));